




import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import Size from "@/models/size";
import SizesAPI from "@/services/sizes";
import SizeForm from "./Components/SizeForm.vue";

@Component({
  components: { SizeForm },
})
export default class NewSize extends Vue {
  async save(size: Size): Promise<void> {
    LayoutModule.showLoader();
    try {
      await SizesAPI.newSize(size);
      LayoutModule.setAlerts({
        text: this.$t("sizes.responses.success_create").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "sizes" });
  }
}
